import {
  BsCircleHalf,
  BsFillCheckCircleFill,
  BsFillXCircleFill,
  BsLink,
  BsThreeDots,
  BsTypeBold,
  BsTypeItalic,
} from 'react-icons/bs';
import {
  FaCalendar,
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaChevronUp,
  FaDownload,
  FaExternalLinkAlt,
  FaFilter,
  FaInfoCircle,
  FaLink,
  FaSitemap,
  FaTable,
  FaUpload,
  FaUser,
} from 'react-icons/fa';
import { FiGitBranch, FiList, FiZoomIn, FiZoomOut } from 'react-icons/fi';
import { GiHamburgerMenu } from 'react-icons/gi';
import { HiOutlineOfficeBuilding } from 'react-icons/hi';
import { HiOutlineSquare3Stack3D } from 'react-icons/hi2';
import { ImSpinner8 } from 'react-icons/im';
import { IoEllipse } from 'react-icons/io5';
import { LuLink2, LuLink2Off } from 'react-icons/lu';
import {
  MdArrowBack,
  MdArrowDownward,
  MdArrowUpward,
  MdClose,
  MdDelete,
  MdDragIndicator,
  MdEdit,
  MdOutlineAdd,
  MdOutlineColorLens,
  MdPreview,
  MdSearch,
  MdSettings,
} from 'react-icons/md';
import { RiAlertFill } from 'react-icons/ri';
import { TbCircleDashed, TbFlag, TbFlagExclamation } from 'react-icons/tb';

import { SitemapExclamation } from './sitemapExclamation.icon';

export const Icons = {
  Edit: MdEdit,
  Delete: MdDelete,
  Drag: MdDragIndicator,
  ChevronDown: FaChevronDown,
  ChevronUp: FaChevronUp,
  ArrowUp: MdArrowUpward,
  ArrowDown: MdArrowDownward,
  ChevronRight: FaChevronRight,
  ChevronLeft: FaChevronLeft,
  ArrowBackward: MdArrowBack,
  Spinner: ImSpinner8,
  Search: MdSearch,
  Upload: FaUpload,
  CheckCircle: BsFillCheckCircleFill,
  XCircle: BsFillXCircleFill,
  Alert: RiAlertFill,
  Ellipse: IoEllipse,
  Ellipses: BsThreeDots,
  Progress: TbCircleDashed,
  HamburgerMenu: GiHamburgerMenu,
  User: FaUser,
  Calendar: FaCalendar,
  Settings: MdSettings,
  Close: MdClose,
  Table: FaTable,
  Add: MdOutlineAdd,
  Info: FaInfoCircle,
  Link: FaLink,
  Filter: FaFilter,
  Download: FaDownload,
  CircleHalf: BsCircleHalf,
  Inherited: LuLink2,
  NotInherited: LuLink2Off,
  Bold: BsTypeBold,
  Italic: BsTypeItalic,
  Link2: BsLink,
  Preview: MdPreview,
  Flag: TbFlag,
  FlagExclamation: TbFlagExclamation,
  ThemeSettings: MdOutlineColorLens,
  GitBranch: FiGitBranch,
  List: FiList,
  ZoomIn: FiZoomIn,
  ZoomOut: FiZoomOut,
  Sitemap: FaSitemap,
  SitemapExclamation,
  OfficeBuilding: HiOutlineOfficeBuilding,
  Stack: HiOutlineSquare3Stack3D,
  ExternalLink: FaExternalLinkAlt,
};

export type IconKeys = keyof typeof Icons;
